import React from 'react';
import Button from '@material-ui/core/Button';
import {withStyles} from "@material-ui/core";
import {Styles} from "../../../config/design/styles";
import {connect} from "trim-redux";
import Dialog from "@material-ui/core/Dialog/Dialog";
import DialogTitle from "@material-ui/core/DialogTitle/DialogTitle";
import DialogContent from "@material-ui/core/DialogContent/DialogContent";
import DialogContentText from "@material-ui/core/DialogContentText/DialogContentText";
import DialogActions from "@material-ui/core/DialogActions/DialogActions";
import {withSnackbar} from "notistack";
import {withRouter} from "react-router";
import {Link} from "react-router-dom";
import {Translate} from "../../../config/Translate";
class CheckForUserConfirmed extends React.Component{
    open = this.props.new;

    state= {
        is_uncompleted: this.props.user.confirmed === "uncompleted",
        is_pending: this.props.user.confirmed === "pending",
    };
    classes = this.props.classes;
    render(){
    let {is_uncompleted,is_pending}  = this.state;

        return (
            <>
                <Dialog
                    open={is_uncompleted || is_pending}
                    aria-labelledby="alert-dialog-title"
                    aria-describedby="alert-dialog-description"
                >
                    {
                        is_uncompleted &&
                            <>
                                <DialogTitle id="alert-dialog-title">
                                    {Translate.fillYourDetailsFirst}
                                </DialogTitle>
                                <DialogContent>
                                    <DialogContentText id="alert-dialog-description">
                                        {Translate.fillYourDetailsFirstDescription}
                                    </DialogContentText>
                                </DialogContent>
                                <DialogActions>
                                    <Button component={Link} to="/account/details" color="primary">
                                        {Translate.myAccount}
                                    </Button>
                                </DialogActions>
                            </>
                    }
                    {
                        is_pending &&
                        <>
                            <DialogTitle id="alert-dialog-title">
                                {Translate.yourAccountInfoIsPending}
                            </DialogTitle>
                            <DialogContent>
                                <DialogContentText id="alert-dialog-description">
                                    {Translate.yourAccountInfoIsPendingDesc}
                                </DialogContentText>
                            </DialogContent>
                            <DialogActions>
                                <Button component={Link} to="/account/details" color="primary">
                                    {Translate.myAccount}
                                </Button>
                            </DialogActions>
                        </>
                    }
                </Dialog>
            </>
        );
    }
}
const mstp = state => ({
    isAuth: state.isAuth,
    user: state.user,
    primary_shop: state.primary_shop,
});
export default withSnackbar(withRouter(withStyles(Styles)(connect(mstp)(CheckForUserConfirmed))));